<template>
  <EditorNodeWrapper
    :class="[
      'node-container',
      'link-container',
      blockWidthClass,
      {
        'parent-first-child': parentFirstChild,
        'parent-last-child': parentLastChild,
      },
    ]"
    @observe-node-visibility="$emit('observe-node-visibility', { ...$event, nodeId: node.id })"
  >
    <FriedButton
      :class="[
        'open-link-btn',
        node.align.toLowerCase(),
        { 'themed-button': !!buttonBackgroundColor },
      ]"
      data-external="view-link-button"
      @click="handleClick"
    >
      <ProsemirrorViewerInput class="open-link-btn-text" :content="node.content" />
    </FriedButton>
  </EditorNodeWrapper>
</template>
<script lang="ts" setup>
import type { EBlockWidth, Link } from '@getaccept/editor-lib';
import { UrlHelper } from '@getaccept/lib-shared/src/helpers/url.helper';
import { computed } from 'vue';
import { useInjectEditorViewState } from '../composables/editor-view-state.composable';
import ProsemirrorViewerInput from './ProsemirrorViewerInput.vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';

const {
  node = undefined,
  parentFirstChild = false,
  parentLastChild = false,
  blockWidthClass = null,
} = defineProps<{
  node?: Link;
  parentFirstChild?: boolean;
  parentLastChild?: boolean;
  blockWidthClass?: EBlockWidth;
}>();

const emit = defineEmits<{
  'observe-node-visibility': [{ nodeId: string }];
  'node-click': [{ nodeId: string }];
}>();

const handleClick = () => {
  if (!node.linkUrl) {
    return;
  }
  const url = UrlHelper.getHttpsUrl(node.linkUrl);
  window.open(url, '_blank');
  emit('node-click', { nodeId: node.id });
};

const { uiStyling } = useInjectEditorViewState();

const buttonBackgroundColor = computed(() => uiStyling.value?.color);
const buttonHoverColor = computed(() => uiStyling.value?.buttonHoverBackgroundColor);
const buttonTextColor = computed(() => uiStyling.value?.buttonTextColor);
</script>
<style lang="scss" scoped>
@import '@getaccept/editor-lib/src/scss/editor-node-link';

.open-link-btn-text {
  cursor: pointer;
}

.themed-button.button.ga-primary {
  background-color: v-bind(buttonBackgroundColor) !important;
  color: v-bind(buttonTextColor) !important;

  &:hover {
    background-color: v-bind(buttonHoverColor) !important;
  }

  &:focus {
    background-color: v-bind(buttonBackgroundColor) !important;
  }
}
</style>
